import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";
import { vehicles } from "./vehicles";

// ============================================================================
// vehicle_images — รูปภาพรถ
// ============================================================================
export const vehicleImages = sqliteTable("car_rental_vehicle_images", {
  id: text("id").primaryKey(), // ULID
  vehicleId: text("vehicle_id").notNull().references(() => vehicles.id),
  imageUrl: text("image_url").notNull(),
  caption: text("caption"),
  sortOrder: integer("sort_order").notNull().default(0),
  // Timestamps & Audit
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type VehicleImage = typeof vehicleImages.$inferSelect;
export type NewVehicleImage = typeof vehicleImages.$inferInsert;
